<template>
    <div>
        <h1>LINKS</h1>
        <ul>
            <li v-for="link in links" :key="link.id">
                <a :href="link.link" target="_blank" v-text="link.link"></a>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'ChatLinks',
    computed: {
        links() {
            return this.$store.state.projects.links.all
        },
    },
}
</script>
<style lang="scss" scoped>
ul {
    list-style: none;
    margin: 0;
    padding: 0;

    a {
        display: block;
        padding: .5rem;

        &:hover {
            background-color: var(--bg-color-2);
        }
    }
}
</style>
